import { render } from "./BaseSlider.vue?vue&type=template&id=68525f9e&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=68525f9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68525f9e"]])

export default __exports__